import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { GovernancePanel } from '@/components/governance/GovernancePanel';
import { trpc } from '@/lib/trpc';

/**
 * Permisos del área Pipeline comercial del Brain (T4b): quién ve los cortes por owner
 * (desempeño individual) y quién administra este panel. Ver el área la da el roster de
 * usuarios de HubSpot, que el sync espeja a diario (se muestra arriba, con su fecha).
 * Mismo panel genérico que Finance → Control Presupuestario.
 */
export function BrainPipelineGovernanceTab() {
  const { t } = useTranslation();
  const utils = trpc.useUtils();
  const { data: governance, isLoading, isError } = trpc.brain.pipelineGovernance.getGovernance.useQuery(undefined, { retry: false });
  const { data: members = [], isLoading: membersLoading } = trpc.brain.pipelineGovernance.listCommunityForPicker.useQuery(undefined, { staleTime: 5 * 60_000, retry: false });
  const { data: status } = trpc.brain.pipelineGovernance.status.useQuery(undefined, { retry: false });
  const save = trpc.brain.pipelineGovernance.setGovernance.useMutation({
    onSuccess: () => {
      utils.brain.pipelineGovernance.getGovernance.invalidate();
      utils.brain.pipelineGovernance.checkAccess.invalidate();
      toast.success(t('brain.pipeline_governance.saved'));
    },
    onError: (e) => toast.error(e.message),
  });

  return (
    <GovernancePanel
      namespace="brain.pipeline_governance"
      governance={governance}
      isLoading={isLoading}
      isError={isError}
      members={members}
      membersLoading={membersLoading}
      onSave={(payload, onSuccess) => save.mutate(payload, { onSuccess })}
      saving={save.isPending}
    >
      {status && (
        <div className="rounded-xl border bg-white p-4 text-sm space-y-1">
          <p className="font-medium text-gray-900">{t('brain.pipeline_governance.status_title')}</p>
          <p className="text-gray-700">
            {t('brain.pipeline_governance.status_roster', { count: status.roster.total, date: status.roster.updatedAt?.slice(0, 10) ?? '-' })}
          </p>
          <p className="text-gray-700">
            {status.digest
              ? t('brain.pipeline_governance.status_digest', { date: status.digest.today, open: status.digest.stats.openDeals, snapshots: status.digest.stats.snapshotDates })
              : t('brain.pipeline_governance.status_no_digest')}
          </p>
        </div>
      )}
    </GovernancePanel>
  );
}
